import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';

interface AddChoiceFormProps {
  optIndex: number;
  onAddChoice: (optIdx: number, label: string, cost: number) => void;
}

const AddChoiceForm: React.FC<AddChoiceFormProps> = ({ optIndex, onAddChoice }) => {
  const [label, setLabel] = useState('');
  const [cost, setCost] = useState(0);

  const handleSubmit = (e: React.MouseEvent) => {
    e.preventDefault();
    if (!label.trim()) return;
    onAddChoice(optIndex, label, cost);
    setLabel('');
    setCost(0);
  };

  return (
    <div className="d-flex align-items-center gap-2 bg-light-subtle border border-dashed p-2 rounded-3 mt-2">
      <Form.Control
        type="text"
        size="sm"
        placeholder="New choice label (e.g. Spot UV Gloss)"
        value={label}
        onChange={(e) => setLabel(e.target.value)}
        style={{ borderRadius: '6px', fontSize: '12px' }}
      />
      <div className="d-flex align-items-center gap-1" style={{ width: '130px' }}>
        <span style={{ fontSize: '11px' }} className="text-muted">+₹</span>
        <Form.Control
          type="number"
          step="0.01"
          size="sm"
          placeholder="Extra cost"
          value={cost}
          onChange={(e) => setCost(parseFloat(e.target.value) || 0)}
          style={{ borderRadius: '6px', fontSize: '12px' }}
        />
      </div>
      <Button
        variant="primary"
        size="sm"
        onClick={handleSubmit}
        style={{ borderRadius: '6px', fontSize: '11.5px' }}
        className="px-3"
      >
        Add Choice
      </Button>
    </div>
  );
};

export default AddChoiceForm;
